var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveConversion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.72,
    fill: "#1778F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20186_136101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 16.0013H17.25M12.25 12.668H14.75",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0835 22.668C13.9588 23.3927 15.0122 23.8545 16.2197 23.9336C17.1712 23.9961 18.1644 23.996 19.1139 23.9336C19.4408 23.9122 19.7972 23.8352 20.1042 23.7105C20.4456 23.5717 20.6164 23.5023 20.7032 23.5128C20.79 23.5233 20.9159 23.615 21.1677 23.7982C21.6117 24.1213 22.1711 24.3534 23.0006 24.3335C23.42 24.3234 23.6297 24.3183 23.7236 24.1604C23.8175 24.0024 23.7006 23.7837 23.4667 23.3464C23.1423 22.7398 22.9368 22.0454 23.2482 21.489C23.7846 20.6942 24.2401 19.7531 24.3067 18.7366C24.3424 18.1904 24.3424 17.6247 24.3067 17.0786C24.2623 16.4012 24.0979 15.7574 23.8345 15.168",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2876 20.5736C19.2506 20.3785 21.6107 18.0071 21.8049 15.03C21.8429 14.4474 21.8429 13.8441 21.8049 13.2615C21.6107 10.2844 19.2506 7.91298 16.2876 7.71784C15.2767 7.65128 14.2214 7.65141 13.2126 7.71784C10.2496 7.91298 7.88946 10.2844 7.69525 13.2615C7.65725 13.8441 7.65725 14.4474 7.69525 15.03C7.76598 16.1143 8.25001 17.1182 8.81985 17.966C9.15071 18.5594 8.93236 19.3001 8.58773 19.9471C8.33925 20.4136 8.21501 20.6469 8.31476 20.8154C8.41451 20.9839 8.63735 20.9893 9.08301 21.0001C9.96435 21.0213 10.5586 20.7737 11.0304 20.4291C11.2979 20.2336 11.4317 20.1359 11.5239 20.1247C11.6161 20.1135 11.7976 20.1875 12.1604 20.3356C12.4865 20.4686 12.8652 20.5507 13.2126 20.5736C14.2214 20.6401 15.2767 20.6401 16.2876 20.5736Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20186_136101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveConversion);
export default __webpack_public_path__ + "static/media/activeConversion.d011a81e2cd295a1b0750513a418c880.svg";
export { ForwardRef as ReactComponent };